import React from 'react';
import { Link } from 'react-router-dom';
import blogPosts from '../data/blog-posts';
import { useTranslation } from 'react-i18next';

const BlogSidebar = () => {

    const { t } = useTranslation();

    return (
        <aside className="sidebar-area">
            <div className="widget widget_search" data-cue="slideInUp">
                <h3 className="widget_title">{t('sections.blogSidebar.search_title','Search Now')}</h3>
                <form className="search-form">
                    <input type="text" placeholder={t('sections.blogSidebar.search_placeholder','Search')} />
                    <button type="submit">
                        <i className="far fa-search" />
                    </button>
                </form>
            </div>
            <div className="widget widget_categories" data-cue="slideInUp">
                <h3 className="widget_title">{t('sections.blogSidebar.categories_title','Categories')}</h3>
                <ul>
                    <li>
                        <Link to="/blog">{t('sections.blogSidebar.categories.cloud_security_management','Cloud Security Management')}</Link>
                    </li>
                    <li>
                        <Link to="/blog">{t('sections.blogSidebar.categories.cloud_workload_protection','Cloud Workload Protection')}</Link>
                    </li>
                    <li>
                        <Link to="/blog">{t('sections.blogSidebar.categories.casab','Cloud Access Security Broker')}</Link>
                    </li>
                    <li>
                        <Link to="/blog">{t('sections.blogSidebar.categories.cloud_security_management','Cloud Security Management')}</Link>
                    </li>
                    <li>
                        <Link to="/blog">{t('sections.blogSidebar.categories.endpoint_detection','Endpoint Detection')}</Link>
                    </li>
                </ul>
            </div>
            <div className="widget  " data-cue="slideInUp">
                <h3 className="widget_title">{t('sections.blogSidebar.recent_posts','Recent Posts')}</h3>
                <div className="recent-post-wrap">
                    {blogPosts.slice(0, 3).map((post) => (
                        <div className="recent-post" key={post.id}>
                            <div className="media-img">
                                <Link to={`/blog/${post.slug}`}>
                                    <img
                                        src={post.image}
                                        alt={t(`sections.blogPosts.post_${post.id}.title`, post.title)}
                                    />
                                </Link>
                            </div>
                            <div className="media-body">
                                <div className="recent-post-meta">
                                    <Link to="/blog">
                                        <i className="fas fa-calendar-days" />
                                        {post.date}
                                    </Link>
                                </div>
                                <h4 className="post-title">
                                    <Link className="text-inherit" to={`/blog/${post.slug}`}>
                                        {t(`sections.blogPosts.post_${post.id}.title`, post.title)}
                                    </Link>
                                </h4>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="widget widget_tag_cloud" data-cue="slideInUp">
                <h3 className="widget_title">{t('sections.blogSidebar.popular_tags','Popular Tags')}</h3>
                <div className="tagcloud">
                    <Link to="/blog?tag=cyber">{t('sections.blogSidebar.tags.cyber','Cyber')}</Link>
                    <Link to="/blog?tag=hacking">{t('sections.blogSidebar.tags.hacking','Hacking')}</Link>
                    <Link to="/blog?tag=data">{t('sections.blogSidebar.tags.data','Data')}</Link>
                    <Link to="/blog?tag=ddos">{t('sections.blogSidebar.tags.ddos','DDos')}</Link>
                    <Link to="/blog?tag=learning">{t('sections.blogSidebar.tags.learning','Learning')}</Link>
                    <Link to="/blog?tag=google">{t('sections.blogSidebar.tags.google','Google')}</Link>
                    <Link to="/blog?tag=cyber-security">{t('sections.blogSidebar.tags.cyber_security','Cyber Security')}</Link>
                    <Link to="/blog?tag=cyber-course">{t('sections.blogSidebar.tags.cyber_course','Cyber Course')}</Link>
                </div>
            </div>
        </aside>
    );
};

export default BlogSidebar;